
import React from "react";
import { Button } from "@/components/ui/button";
import { Loader2, Save } from "lucide-react";
import { useToast } from "@/hooks/use-toast";

interface SaveChangesButtonProps {
  isSaving: boolean;
  onSave: () => void;
  isDirty?: boolean;
}

const SaveChangesButton: React.FC<SaveChangesButtonProps> = ({ 
  isSaving, 
  onSave,
  isDirty = true
}) => {
  const { toast } = useToast();

  const handleSaveClick = () => {
    if (!isDirty) {
      toast({
        title: "No changes to save",
        description: "Make some changes first before saving.",
        variant: "default",
      });
      return;
    }
    onSave();
  };

  return (
    <div className="flex justify-end mt-6">
      <Button 
        onClick={handleSaveClick} 
        disabled={isSaving || !isDirty}
        className="gap-2"
      >
        {isSaving ? (
          <>
            <Loader2 className="h-4 w-4 animate-spin" />
            Saving...
          </>
        ) : (
          <>
            <Save className="h-4 w-4" />
            Save Changes
          </>
        )}
      </Button>
    </div>
  );
};

export default SaveChangesButton;
